import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_DISCOUNT_FILTER,
  REQUEST_CREATE_MASTER_DISCOUNT_FILTER,
  SET_MASTER_DISCOUNT_FILTER,
  SUCCESS_CREATE_MASTER_DISCOUNT_FILTER,
  ERROR_GET_MASTER_DISCOUNT_FILTER,
  ERROR_CREATE_MASTER_DISCOUNT_FILTER,
  SUCCESS_UPDATE_MASTER_DISCOUNT_FILTER,
  ERROR_UPDATE_MASTER_DISCOUNT_FILTER,
  SUCCESS_DELETE_MASTER_DISCOUNT_FILTER,
  ERROR_DELETE_MASTER_DISCOUNT_FILTER,
  REQUEST_UPDATE_MASTER_DISCOUNT_FILTER,
  REQUEST_DELETE_MASTER_DISCOUNT_FILTER,
  SET_MASTER_DISCOUNT_FILTER_CATEGORIES,
  ERROR_GET_MASTER_DISCOUNT_FILTER_CATEGORIES,
  REQUEST_MASTER_DISCOUNT_FILTER_CATEGORIES,
} from "./discountfilterActionTypes";

function* requestMasterDiscountFilter(action: Record<string, any>): any {
  try {
    const result: any = yield call(getDiscountFilterMaster);
    yield put({ type: SET_MASTER_DISCOUNT_FILTER, payload: result.data.data });
    // console.log(result.data);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_DISCOUNT_FILTER, payload: message });
  }
}

function* requestMasterDiscountFilterCat(action: Record<string, any>): any {
  try {
    const result: any = yield call(getDiscountFilterMaster);
    yield put({
      type: SET_MASTER_DISCOUNT_FILTER_CATEGORIES,
      payload: result.data.data.categories,
    });
    // console.log(result.data);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({
      type: ERROR_GET_MASTER_DISCOUNT_FILTER_CATEGORIES,
      payload: message,
    });
  }
}

function* requestUpdateMasterDiscountFilter(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterDiscountFilter,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_DISCOUNT_FILTER,
      payload: result.data.data,
    });
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_DISCOUNT_FILTER, payload: message });
  }
}

function* requestDeleteMasterDiscountFilter(action: Record<string, any>): any {
  try {
    yield call(deleteMasterDiscountFilter, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_DISCOUNT_FILTER,
      payload: get(action, "payload._id", ""),
    });
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_DISCOUNT_FILTER, payload: message });
  }
}

function* requestCreateMasterDiscountFilter(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterDiscountFilter, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_DISCOUNT_FILTER,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_DISCOUNT_FILTER, payload: message });
  }
}

export function getDiscountFilterMaster() {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/admin/discount`,
    withCredentials: true,
  });
}

export function createMasterDiscountFilter(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/discount`,
    data: payload,
    withCredentials: true,
  });
}

export function deleteMasterDiscountFilter(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/discount/${_id}`,
    withCredentials: true,
  });
}
export function updateMasterDiscountFilter(
  payload: Record<string, any>,
  _id: string
) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/discount/${_id}`,
    data: payload,
    withCredentials: true,
  });
}

const discountFilterMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_DISCOUNT_FILTER, requestMasterDiscountFilter),
    takeLatest(
      REQUEST_MASTER_DISCOUNT_FILTER_CATEGORIES,
      requestMasterDiscountFilterCat
    ),
    takeLatest(
      REQUEST_CREATE_MASTER_DISCOUNT_FILTER,
      requestCreateMasterDiscountFilter
    ),
    takeLatest(
      REQUEST_UPDATE_MASTER_DISCOUNT_FILTER,
      requestUpdateMasterDiscountFilter
    ),
    takeLatest(
      REQUEST_DELETE_MASTER_DISCOUNT_FILTER,
      requestDeleteMasterDiscountFilter
    ),
  ]);
};

export default discountFilterMasterSaga;
